<template>
    <div>
        <div class="row" style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l3 l6 offset-xl3 xl6">
                <h5 class="center-align white-text">
                    Редактирование данных пользователя "{{user.login}}"
                </h5>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg"
                       :data-login="user.login"
                       :data-id="user.id">
                    <tbody>
                    <tr>
                        <td colspan="2" class="row">
                            <div>
                                <a
                                   @click="deleteUser"
                                   style="width: 50px;"
                                   class="btn red darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 left">
                                    <i class="material-icons">delete</i>
                                </a>
                                <a @click="$router.push('/users')"
                                   style="width: 50px;"
                                   class="btn grey darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 right">
                                    <i class="material-icons">keyboard_backspace</i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    <tr :key="user.id">
                        <td>логин</td>
                        <td>{{user.login}}</td>
                    </tr>
                    <tr>
                        <td>заметка</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="textarea1"
                                                  v-if="((user.password !== null) && (user.password !== ''))"
                                                  class="materialize-textarea"
                                                  v-model="user.note">
										</textarea>
                                <p align="left" v-else>Это пользователь из биллинга, редактирование запрещенно</p>
                                <label for="textarea1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>включен</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.enabled"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Запись DVR</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.dvr_allowed"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>пароль</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12 offset-xl2 xl8">
                                <input type="password"
                                       v-if="((user.password !== null) && (user.password !== ''))"
                                       id="autocomplete-pass"
                                       @keyup="setPass($event)"
                                       @blur="blur"
                                       v-model.lazy="user.password"
                                       :class="((user.password !== user.confirmPassword)
									                        && ($v.confirmPassword.$dirty && $v.password.$dirty))
									                        ?
									                        'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>подтверждение пароля</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12  offset-xl2 xl8">
                                <input type="password"
                                       v-if="((user.password !== null) && (user.password !== ''))"
                                       id="autocomplete-confirm-pass"
                                       @keyup="setConfirmPass($event)"
                                       @blur="blur"
                                       v-model.lazy="confirmPassword"
                                       :class="((user.password !== user.confirmPassword)
									                        && ($v.confirmPassword.$dirty && $v.password.$dirty))
								                            ?
								                            'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-confirm-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="row"
                            colspan="2">
                            <a class="btn indigo lighten-1 waves-effect waves-light btn-small col s12 m5 l5 xl5"
                               style="margin: 5px 0;"
                               @click="$router.push(`/cameras/get/${user.login}/${getUsersType(user.note)}`)">
                                <i class="material-icons left">videocam</i>
                                список камер - {{user.camera_count}}
                            </a>
                            <div class="col hide-on-small-only m2 l2 xl2"></div>
                            <a @click="save"
                               v-if="((user.password !== null) && (user.password !== ''))"
                               style="margin: 5px 0;"
                               :class="{disabled: (user.password !== user.confirmPassword)
					                        && ($v.confirmPassword.$dirty && $v.password.$dirty)}"
                               class="btn teal lighten-1 waves-effect
									    waves-light btn-small width-btn col s12 m5 l5 xl5">
                                <i class="material-icons left"
                                >save</i>
                                Сохранить</a>

                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import setRules from "../../assets/setRules";
    import {eventEmitter} from "../../main";
    import {mapState, mapMutations} from "vuex";
    import Swal from 'sweetalert2'
    import Users from "../../plugins/controllers/users";

    export default {
        name: "EditUser",
        data() {
            return {
                 password: "",
                 confirmPassword: "",
                user: {
                    enabled: null,
                    id: null,
                    login: "",
                    note: "",
                    dvr_allowed: null,
                    password: null,
                    confirmPassword: null,
                    camera_count: 0
                }
            };
        },
        validations: {
            password: {},
            confirmPassword: {}
        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getAdmin);
        },
        beforeDestroy() {
            eventEmitter.$off("tokenSuccess", this.getAdmin);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getUser();
            } else {
                console.log("token is not success");
            }
        },
        computed: {
            ...mapState(["tokenSuccess"])
        },
        methods: {
            ...mapMutations(["setAuth", "setShowMenu"]),
            deleteUser() {
                if (this.id !== null) {
                    Swal.fire({
                        title: 'Удалить пользователя?',
                        text: "Пользователь будет удален навсегда!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Отмена',
                        confirmButtonText: 'Удалить!'
                    }).then((result) => {
                        if (result.value) {
                            Users.deleteUser(this.user.id).then((response) => {
                                setRules(response);
                                if (response.data.success) {
                                    Swal.fire(
                                        'Удалено!',
                                        'Пользователь удален.',
                                        'success'
                                    ).then((result) => {
                                        this.$router.push("/users");
                                    })
                                } else {
                                    Swal.fire(
                                        'Не Удалено!',
                                        'Пользователь не был удален.',
                                        'error'
                                    )
                                }
                            }).catch((error) => {
                                Swal.fire(
                                    'Не Удалено!',
                                    'Возникла ошибка на сервере',
                                    'error'
                                )
                            });
                        }
                    })
                }
            },
            save() {
                let swalOptions = {
                    title: 'Сохранить изменения?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Сохранить!'
                };
                if (this.user.confirmPassword === null && (this.user.password !== "")) {
                    swalOptions.text = "Пароль НЕ будет изменен!";
                } else {
                    swalOptions.text = "Пароль БУДЕТ изменен!";
                }
                Swal.fire(swalOptions).then((result) => {
                    if (result.value) {

                        Users.updateUser(this.user).then((response) => {
                            setRules(response);
                            if (Number.isInteger(response.data.id)) {
                                Swal.fire(
                                    'Обновленно!',
                                    'Пользователь обновлен',
                                    'success'
                                ).then((result) => {
                                    this.$router.push("/users");
                                })
                            } else {
                                Swal.fire(
                                    'Не Обновленно!',
                                    'Пользователь не был обновлен.',
                                    'error'
                                )
                            }
                        }).catch((error) => {
                            console.log(error);
                            Swal.fire(
                                'Не Обновленно!',
                                'Возникла ошибка на сервере',
                                'error'
                            )
                        });
                    }
                })

            },
            getUser() {
                console.log(this.$route.params.login);
                Users.getUser(this.$route.params.login).then((response) => {
                    setRules(response);
                    this.user.enabled = response.data.enabled;
                    this.user.id = response.data.id;
                    this.user.login = response.data.login;
                    this.user.note = response.data.note;
                    this.user.dvr_allowed = response.data.dvr_allowed;
                    this.user.password = response.data.password;
                    this.user.camera_count = response.data.camera_count;
                }).catch((error) => {
                    console.log(error)
                })
            },
            blur() {
                if (this.$v.confirmPassword.$dirty && this.$v.password.$dirty) {
                    this.user.password = this.password;
                    this.user.confirmPassword = this.confirmPassword;
                }
            },
            setPass(event) {
                this.password= event.target.value;
                this.$v.password.$touch();
            },
            setConfirmPass(event) {
                if (event.target.value === "") {
                    this.$v.confirmPassword.$reset();
                } else {
                    this.$v.confirmPassword.$touch();
                }
                this.confirmPassword = event.target.value;
            },
            getUsersType(data) {
                if (data === "user from Bugs") {
                    return "bugs";
                } else {
                    return "local";
                }
            }
        }
    };
</script>
<style scoped lang="scss">
    .bold {
        font-weight: 500;
    }

    @media screen and (max-width: 600px) {
        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    input[type="password"] {
        transition: all 0.3s
    }

    input[type="password"].disable {
        visibility: hidden;
    }

    input[type="password"].error {
        color: #c62828;
        border-bottom: 1px solid #c62828;
        box-shadow: 0 1px 0 #c62828;

        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #c62828;
            box-shadow: 0 1px 0 #c62828;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #c62828;
        }
    }

    textarea, input {

        color: #fff;
        transition: all 0.3s;
    }

    textarea:not(.browser-default):focus:not([readonly]) {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    input[type="password"], input[type="text"] {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    .parallax-container {
        height: auto;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr > td:first-child {
        padding-left: 12px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    .input-field {
        padding-right: 0;
        margin: 0;
    }

    tr td:first-child {
        width: 20%;
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

    .width-btn {
        margin: 10px;
    }
</style>
